<template>
  <svg>
    <svg-wave-lines
      v-for="(dataset, index) in datasets"
      :key="dataset.name"
      :d="dataset"
      :o="options"
      :points="points[index]"
      :svg="svg"
    ></svg-wave-lines>
  </svg>
</template>

<script>
import { TimelineMax, Linear } from 'gsap';
import svgWaveLines from './SVGWavesLine';

export default {
  components: {
    svgWaveLines
  },

  props: {
    datasets: { type: Array, default: null },
    options: { type: Object, default: null },
    svg: { type: Object, default: null },
    start: {
      type: Boolean,
      default: false
    },
    vertecies: { type: Array, default: null }
  },
  data: () => ({
    tickCount: 0,
    vertex1: [{ a: 1 }, { a: 2 }, { a: 3 }, { a: 4 }, { a: 5 }, { a: 6 }],
    vertex2: [{ a: 1 }, { a: 2 }, { a: 3 }, { a: 4 }, { a: 5 }, { a: 6 }]
  }),
  computed: {
    viewbox() {
      return `0 0 ${this.svg.w} ${this.svg.h}`;
    },
    points: function() {
      const points = [[], []];
      const w = 90;

      for (let i = 0; i < 6; i++) {
        points[0][i] = [w * i, this.vertex1[i].a];
        points[1][i] = [w * i, this.vertex2[i].a];
      }

      return points;
    }
  },
  watch: {
    start: function() {
      this.startAnimationRandom(this.vertecies);
    }
  },
  mounted: function() {
    this.startAnimationRandom(this.vertecies);
  },
  methods: {
    startAnimationRandom(pointsNew) {
      const scaleY = 0.6;
      const delayBlue = 0.5;
      const delayGreen = 0.5;

      const newVerticies = [];
      const newVerticies2 = [];

      for (let x = 0; x < 4; x++) {
        newVerticies[x] = pointsNew[0][x + 1];
        newVerticies2[x] = pointsNew[1][x + 1];
      }

      // vertex by vertex:
      const tl = new TimelineMax();
      for (let i = 0; i < 4; i++) {
        const element = this.vertex1[i];

        tl.to(
          element,
          delayGreen,
          {
            a: newVerticies[i] * scaleY,
            ease: Linear.easeNone
          },
          0
        );
      }

      const tlBlue = new TimelineMax();
      for (let i = 0; i < 4; i++) {
        const element = this.vertex2[i];

        tlBlue.to(
          element,
          delayBlue,
          {
            a: newVerticies2[i] * scaleY,
            ease: Linear.easeNone
          },
          0
        );
      }

      tlBlue.add(() => {
        this.$emit('endWave', this.tickCount++);
      });
    }
  }
};
</script>

<style scoped></style>
